import React, { useEffect } from 'react'
import { LuCrown, LuCheck } from 'react-icons/lu';
import { TfiHeadphoneAlt } from "react-icons/tfi";

import './premiumUpg.css'
import { Images } from 'constants';

const PremiumUpgradModal = (props) => {
    let {
        onRefresh,
        onUpdate = () => { },
        onContinue = () => { },
        isOpen,
        onClose = () => { },
        modalZIndex = 1050,
    } = props;

    const features = [
        'Mobile/ Desktop Access',
        'Sync across all devices',
        'Priority Customer Support',
        'Advance Tools',
        'Advanced analytics & reporting',
        'Multi User Management',
    ];

    // ✅ Body scroll lock jab modal open ho
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    // ✅ Backdrop click handler
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose(e);
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className="__upgPr_backdrop"
            onClick={handleBackdropClick}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: modalZIndex,
            }}
        >
            <div
                className='__upgPr_mainBody'
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '16px',
                    maxWidth: '500px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    position: 'relative',
                }}
            >
                {/* Header */}
                <div className='__upgPr_header'>
                    <div className='__upgPr_crownBox'>
                        <LuCrown />
                    </div>
                    <h2>Upgrade to Premium</h2>
                    <div className='__upgPr_subText'>
                        <p>Web Access Expired</p>
                        <span>
                            Upgrade your plan or continue using mobile app for free
                        </span>
                    </div>
                </div>

                {/* Included Box */}
                <div className='__upgPr_includeBox'>
                    <div className='__upgPr_includeTag'>
                        Whats Included
                    </div>
                    <div className='__upgPr_featureGrid'>
                        {features?.map((item, index) => (
                            <div className='__upgPr_featureItem' key={index}>
                                <LuCheck />
                                <p>{item}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Upgrade Button */}
                <button
                    className='__upgPr_upgradeBtn'
                    onClick={onUpdate}
                >
                    <span>Upgrade Now</span>
                    <p>Plan start from ₹ 14/ Day</p>
                </button>

                {/* Store Buttons */}
                <div className='__upgPr_storeBtns'>
                    <button className='__upgPr_storeBtn'>
                        <img src={Images.GOOGLE_PLAY.default} alt="google-play" />
                    </button>
                    <button className='__upgPr_storeBtn'>
                        <img src={Images.APPLE_STORE.default} alt="app-store" />
                    </button>
                </div>

                {/* Contact */}
                <div className='__upgPr_contact'>
                    <TfiHeadphoneAlt />
                    <span>Contact Sales: +91 7566514634</span>
                </div>
            </div>
        </div>
    )
}

export default PremiumUpgradModal